import { computed } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { patchState, signalStore, withComputed, withMethods, withProps, withState } from '@ngrx/signals';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserAccount } from '../models';
import { LanguageEnum } from '../enums';

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: UserAccount | null;
  language: LanguageEnum;
  isRefreshing: boolean;
}

const initialState: AuthState = {
  accessToken: null,
  refreshToken: null,
  user: null,
  language: LanguageEnum.English,
  isRefreshing: false,
};

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => ({
    authenticated: computed(() => !!store.accessToken()),
  })),
  withProps((store) => ({
    authenticated$: toObservable(store.accessToken).pipe(map((token) => !!token)),
    refreshTokenSubject: new Subject<string>(),
  })),
  withMethods((store) => ({
    setAccessToken(accessToken: string | null): void {
      patchState(store, { accessToken });
    },
    setRefreshToken(refreshToken: string | null): void {
      patchState(store, { refreshToken });
    },
    setUser(user: UserAccount | null): void {
      patchState(store, { user });
    },
    setLanguage(language: LanguageEnum): void {
      patchState(store, { language });
    },
    setIsRefreshing(isRefreshing: boolean): void {
      patchState(store, { isRefreshing });
    },
  })),
);
